/**
 * 历史数据
 */
import React from 'react';
import { Input, Row, Col, Icon, Tooltip, DatePicker, Button } from 'antd';
import PageLayout from '../../ui/PageLayout';
import http from '../../../axios/http';
import messager from '../../ui/messager';
//信息编辑
import ApplicationDetail from './ApplicationDetail';
import OrgSelect from '../../ui/OrgSelect';
import { getBase64 } from '../../../util/util.js';
import Loading from '../../ui/Loading';
import { global_data } from '../../ui/auth'

class ApplicationHistoryIndex extends React.Component {
    columns = [{
        title: '申请单编号',
        dataIndex: 'applicationId',
        width: '10%',
    }, {
        title: '车架号',
        dataIndex: 'vin',
        width: '12%',
    }, {
        title: '车牌号',
        dataIndex: 'plateNo',
        width: '8%',
    }, {
        title: '新车主',
        dataIndex: 'buyerName',
        width: '10%',
    }, {
        title: '旧车主',
        dataIndex: 'sellerName',
        width: '10%',
    }, {
        title: '代办公司',
        dataIndex: 'agencyName',
        width: '15%',
    }, {
        title: '申请时间',
        dataIndex: 'insertTime',
        width: '10%',
    }, {
        title: '操作',
        dataIndex: 'id',
        width: '10%',
        render: (text, record, index) => (
            <div>
                <Tooltip title="详情">
                    <Icon type="eye" theme="filled" className="table-operate-icon" onClick={this.detail.bind(this, record.applicationId)} />
                </Tooltip>
                {global_data.authCode.includes("APPLICATION_HISTORY_RETURN")?
                <Tooltip title="回退此流水到申请受理">
                    <Icon type="undo" className="table-operate-icon" onClick={this.rollback.bind(this, record.applicationId)} />
                </Tooltip>
                :""}
            </div>
        ),
    }];

    state = {
        visible: false,
        detailVisible: false,
        loadData: '',

        detailData: {},  //详情页面使用的数据

        queryData: {}, //查询数据

        loadingVisible: false,
    };

    transferData = (res, field) => {
        let buyer = res[field];
        for (let key in buyer) {
            res[field + "." + key] = buyer[key];
        }
        delete res[field];
    }

    //详情
    detail = (info, e) => {
        http.post({
            url: '/applicationHistory/findApplicationDetail',
            data: { applicationId: info },
            success: (res) => {
                this.transferData(res, "buyer");
                this.transferData(res, "seller");
                this.transferData(res, "vehicle");
                //this.transferData(res, "ticket");
                res["vehicle.isImported"] = res["vehicle.isImported"] === 1 ? '是' : '否';
                res["agent"] = res["agent"] === 1 ? '是' : '否';
                this.setState({ detailData: res });
                this.showModalDetal();
            }
        });
    }
    showModalDetal = () => {
        this.setState({ detailVisible: true });
    }
    hiddenModalDetail = () => {
        this.setState({ detailVisible: false });
    }

    //数据退回
    rollback = (info, e) => {
        messager.confirm("是否回滚该流水单据到申请受理中？", () => {
            http.post({
                url: '/applicationHistory/rollbackApplication',
                data: { applicationId: info },
                success: (res) => {
                    messager.notify("回滚该流水单据到申请受理中成功！");
                    this.state.loadData();
                }
            });
        });
    }


    //查询
    inputSearch = (field, value) => {
        let queryData = this.state.queryData;
        queryData[field] = value;
        this.setState({ queryData: queryData });
        this.state.loadData(queryData)
    }

    rangePickerChange = (dates, dateStrings) => {
        let queryData = this.state.queryData;
        queryData.startDate = dateStrings[0];
        queryData.endDate = dateStrings[1];
        this.setState({ queryData: queryData });
        this.state.loadData(queryData);
    }

    //所属市场查询
    orgSelect = (value) => {
        let queryData = this.state.queryData;
        queryData["orgCode"] = value;
        this.setState({ queryData: queryData });
        this.state.loadData(queryData)
    }

    //选择文件
    uploadFile = (index, e) => {
        this.setState({ loadingVisible: true })
        let file = e.target.files[0];
        getBase64(file).then(base64 => {
            http.download({
                url: '/applicationHistory/downloadTradeInfo',
                data: {
                    "type": index,
                    "fileName": file.name,
                    "file": base64
                },
                fileName: file.name,
                success: (res) => {
                    this.setState({ loadingVisible: false });
                },
                error: (res) => {
                    this.setState({ loadingVisible: false });
                }
            });
        })
            .catch(
                (error) => {
                    this.setState({ loadingVisible: false });
                }
            );
        e.target.value = ''
    }

    render() {
        return (
            <div style={{ width: '100%', height: '100%' }}>
                <PageLayout
                    condition={(
                        <Row>
                            <Col span={24}>
                                <Input.Search
                                    placeholder="车牌号/车架号"
                                    onSearch={this.inputSearch.bind(this, "queryString")}
                                    enterButton
                                    style={{ width: '200px', marginRight: '10px' }}
                                />
                                <Input.Search
                                    placeholder="代办公司"
                                    onSearch={this.inputSearch.bind(this, "agencyName")}
                                    enterButton
                                    style={{ width: '200px', marginRight: '10px' }}
                                />
                                <Input.Search
                                    placeholder="旧车主"
                                    onSearch={this.inputSearch.bind(this, "sellerName")}
                                    enterButton
                                    style={{ width: '200px', marginRight: '10px' }}
                                />
                                <DatePicker.RangePicker onChange={this.rangePickerChange} style={{ marginRight: '10px' }} />

                                <OrgSelect style={{ width: '200px' }}
                                    onChange={this.orgSelect}
                                    allowClear={true}
                                    orgType={4}
                                    lessOneHide={true}
                                    treeDefaultExpandAll={true} />
                                {global_data.authCode.includes("APPLICATION_HISTORY_DATE_MATCH")?
                                <Tooltip title="只能上传xlsx格式的EXCEL，匹配数据的车架号必填！">
                                    <Button type="primary" style={{ float: "right" }} onClick={() => { this.refs.fileInput1.click() }}>数据匹配</Button>
                                </Tooltip>
                                :""}
                                {global_data.authCode.includes("APPLICATION_HISTORY_OUT_MATCH")?
                                <Tooltip title="只能上传xlsx格式的EXCEL，匹配数据的车架号必填！">
                                    <Button type="primary" style={{ float: "right",marginRight: '10px' }} onClick={() => { this.refs.fileInput2.click() }}>转出匹配</Button>
                                </Tooltip>
                                :""}
                                <input type="file" accept=".xlsx" onChange={this.uploadFile.bind(this, 1)} style={{ display: "none" }} ref="fileInput1" />
                                <input type="file" accept=".xlsx" onChange={this.uploadFile.bind(this, 2)} style={{ display: "none" }} ref="fileInput2" />
                            </Col>
                        </Row>
                    )}
                    rowKey="applicationId"
                    url="/applicationHistory/findApplicationPage"
                    columns={this.columns}
                    loadData={(func) => { this.setState({ loadData: func }) }}
                />
                <ApplicationDetail
                    visible={this.state.detailVisible}
                    onCancel={this.hiddenModalDetail.bind(this)}
                    detailData={this.state.detailData}
                />
                <Loading visible={this.state.loadingVisible} message="正在处理中，请稍候..." />
            </div>
        )
    }

}

export default ApplicationHistoryIndex;